import { useSelector } from "react-redux"

import { getBadgeClass } from "helpers/product/badge"
import { cn } from "styles/utils"

const Badge = () => {
  const badge = useSelector((state) => state.wizard.badge)
  const onSale = useSelector((state) => state.wizard.price_and_promo?.on_sale)

  const variant = badge?.label ? badge?.variant : onSale && "sale"
  const label = badge?.label ?? (onSale && "Sale")
  const currentSlideIndex = useSelector(
    (state) => state.previewImage.slideIndex
  )
  const variantClass = getBadgeClass(variant)

  if (!label) return null

  return (
    <span
      className={cn(
        "bg-polar text-black-print text-13 h-18 flex min-w-80 items-center justify-center px-12 font-semibold transition-opacity",
        currentSlideIndex === 0 ? "" : "opacity-0",
        variantClass
      )}
    >
      {label}
    </span>
  )
}

export default Badge
